module.exports = __webpack_public_path__ + "media/images/icon__close--rb-dark-gray@3x-4038fc03d9aa9ba19a8b5e2ffbba0bd2.png";